import React, { useEffect, useState } from "react";

import CreateAccountingSession from "./CreateAccountingSession";
import SingleSessionsTable from "./SingleSessionsTable";

const index = ({ CurrentUser }) => {
  const [CreatedNewSession, setCreatedNewSession] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {(CurrentUser.userType == "Admin" ||
        CurrentUser.userType == "AccountingEmployee" ||
        CurrentUser.userType == "AppointmentEmployee") && (
        <CreateAccountingSession setCreatedNewSession={setCreatedNewSession} />
      )}
      <SingleSessionsTable
        CurrentUser={CurrentUser}
        setCreatedNewSession={() => setCreatedNewSession()}
        CreatedNewSession={CreatedNewSession}
      />
    </div>
  );
};

export default index;
